<template>
    <div class="thickness" :style="{width: width + 'px'}">
        <div v-for="i in count" :key="i" class="layer" :style="{ top: i * 2 + 'px', left: -i + 'px', right: width -i + 'px', bottom: i + 'px', zIndex: count -i }"></div>
    </div>
</template>

<script>
export default {
    props: {
        count: {
            default: 10
        }
    },
    computed: {
        width() {
            return this.count * 2;
        }
    }
}
</script>

<style lang="less" scoped>
.thickness {
    overflow: hidden;
    position: relative;

    .layer {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: white;
        border: 1px solid #ddd;
    }
}
</style>
